let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6wZgZ")).then(() => parcelRequire('di1sw'));